import React, { useState } from "react";

const MoreMessage = ({ moreCount }) => {
    const [moreMessage] = useState(moreCount <= 50 ? `+${moreCount} more.` : "+Many more.");

    return <div className="typeahead-message txt -gray">{moreMessage} Type To Refine…</div>;
};

export default MoreMessage;
